module.exports = __webpack_public_path__ + "img/FR10108.f49a561b.png";